import { useSyncExternalStore } from 'react'

export function useMediaQuery(query: string) {
  const subscribe = (onStoreChange: () => void) => {
    if (
      typeof window === 'undefined' ||
      typeof window.matchMedia !== 'function'
    ) {
      return () => {}
    }

    const media = window.matchMedia(query)
    media.addEventListener('change', onStoreChange)

    return () => media.removeEventListener('change', onStoreChange)
  }

  const getSnapshot = () =>
    typeof window !== 'undefined' && typeof window.matchMedia === 'function'
      ? window.matchMedia(query).matches
      : false

  return useSyncExternalStore(subscribe, getSnapshot, () => false)
}

const breakpoints = {
  xs: '(min-width: 375px)',
  sm: '(min-width: 640px)',
  md: '(min-width: 768px)',
  lg: '(min-width: 1024px)',
  desktop: '(min-width: 1100px)',
  xl: '(min-width: 1280px)',
  '2xl': '(min-width: 1536px)',
}

export type Breakpoint = keyof typeof breakpoints

export const useBreakpoint = (breakpoint: Breakpoint) =>
  useMediaQuery(breakpoints[breakpoint])

// Convenience hooks to check tailwind breakpoints
export const useIsXs = () => useBreakpoint('xs')
export const useIsSm = () => useBreakpoint('sm')
export const useIsMd = () => useBreakpoint('md')
export const useIsLg = () => useBreakpoint('lg')
export const useIsDesktop = () => useBreakpoint('desktop')
export const useIsXl = () => useBreakpoint('xl')
export const useIs2xl = () => useBreakpoint('2xl')
